import './style/index.js';

import _Textarea from './Textarea';

export type { TextareaProps } from './Textarea';
export * from './type';

export const Textarea = _Textarea;
export default Textarea;
